export default {"src":"/_next/static/media/mock_notification.e6259cda.svg","height":20,"width":22,"blurWidth":0,"blurHeight":0};